export { ContentContainer, PageContainer } from './style';
